<template>
    <div>
      <div class="uk-section uk-section-small">
        <div class="uk-grid-small" uk-grid>
          <div class="uk-width-1-1">
            <h3>{{ product.name }}</h3>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-grid-small" uk-grid>
              <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
                <form class="uk-form-horizontal" v-on:submit.prevent="updateProduct">
                  <div class="uk-margin">
                    <div class="uk-inline">
                      <label for="name" class="uk-form-label">Name</label>
                      <div class="uk-form-controls">
                        <input id="name" type="text" class="uk-input" v-model="product.name" placeholder="Enter the name" required>
                      </div>
                    </div>
                  </div>
                  <div class="uk-margin">
                    <div class="uk-inline">
                      <label for="code" class="uk-form-label">Code</label>
                      <div class="uk-form-controls">
                        <input id="code" type="text" class="uk-input" v-model="product.code" placeholder="Enter the code" required>
                      </div>
                    </div>
                  </div>
                  <div class="uk-margin">
                    <div class="uk-inline">
                      <button class="uk-button uk-button-primary">Save</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-width-1-1">
              <h4>Items <small>/ Total: {{ resultCount }} Page: {{ results.length }}</small></h4>
            </div>
            <div class="uk-width-1-1">
              <Ctable :heads="heads"
                      :data="results"
                      :data-objects="dataObjects"
                      :data-icons="{}"
                      :link-base="'item'"
                      :links="{show: true, delete: true}"
                      :name="'items'"/>
            </div>
          </div>
          <div class="uk-width-1-1">
            <Pagination :links="paginationLinks"/>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import Ctable from '@/components/ctable'
  import Pagination from '@/components/pagination'
  import qs from 'query-string'

  export default {
    name: "Show",
    components: {Ctable, Pagination},
    data() {
      return {
        product: {
          name: null,
          code: null,
          created_at: null,
          updated_at: null,
        },
        results: [],
        heads: ['#ID', 'UPC', 'SKU', 'Price', 'Created at'],
        dataObjects: ['id', 'upc', 'sku', 'price', 'created_at'],
        limit: 40,
        offset: 0,
        orderBy: 'desc',
        resultCount: 0,
        paginationLinks: []
      }
    },
    activated() {
      this.getProduct();
    },
    mounted() {
      this.getProduct()
    },
    watch: {
      '$route'() {
        this.getProduct()
      }
    },
    methods: {
      async getProduct() {
        const self = this;

        self.paginationLinks = [];

        self.limit = (typeof self.$route.query.limit !== 'undefined') ? self.$route.query.limit : 40;
        self.offset = (typeof self.$route.query.offset !== 'undefined') ? self.$route.query.offset : 0;
        self.orderBy = (typeof self.$route.query.order_by !== 'undefined') ? self.$route.query.order_by : 'desc';

        self.$request().get(`/product/${self.$route.params.id}`)
          .then(r => {
            r = self.$request().successHandler(r).data.product;

            self.product.name = r.name;
            self.product.code = r.code
            self.product.created_at  = r.created_at;
            self.product.updated_at = r.updated_at;

            self.$request().get(`/product/${self.$route.params.id}/item`, {limit: self.limit, offset: self.offset, order_by: self.orderBy})
              .then(r => {
                r = self.$request().successHandler(r).data;

                self.results = r.items;
                self.resultCount = r.total_count;

                const pages = Math.ceil((self.resultCount / self.limit));

                for(let i = 1; i <= pages; i++) {
                  const link = qs.stringify({limit: self.limit, offset: (self.limit * i - 40), order_by: self.orderBy});
                  self.paginationLinks.push({page: i, link: `?` + link});
                }
              });
          }).catch(e => {
            self.$router.push({name: 'PageNotFound'})
          });
      },
      async updateProduct() {
        const self = this;

        self.$request().put(`/product/${self.$route.params.id}`, {
          name: self.product.name,
          code: self.product.code,
        }).then(r => {
          self.$uikit().notification({
            message: 'The update was successfully completed.',
            status: 'success',
            position: 'top-center',
            timeout: 5000,
          });
        }).catch(e => {
          self.$uikit().notification({
            message: 'Something went wrong! Please try again later.',
            status: 'danger',
            position: 'top-center',
            timeout: 5000,
          });
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/Show.vue